export enum InformationsideRoute {
  INFORMATIONSIDE = 'Information',
  OMMITUDBUD = 'om-udbud-dk',
  PRIVATLIVSPOLITIK = 'privatlivspolitik',
  COOKIES = 'cookies',
  // Hvis denne ændres her, skal den også ændres i BygEmailService.java
  KONTAKT = 'kontakt-udbud-dk',
  HJAELPESIDE = 'Hjælp'
}
